import { Routes, Route } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import AppShell from "./components/AppShell";
import DashboardPage from "./pages/DashboardPage";
import LogsPage from "./pages/LogsPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";

const NotFoundPage = () => (
  <Box sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
    <Stack spacing={2} alignItems="center">
      <Typography variant="h3" sx={{ fontFamily: "Sora, DM Sans, sans-serif" }}>
        Page not found
      </Typography>
      <Typography color="text.secondary">
        The page you are looking for does not exist or has moved.
      </Typography>
      <Button variant="contained" component={RouterLink} to="/">
        Return to dashboard
      </Button>
    </Stack>
  </Box>
);

const App = () => (
  <Routes>
    <Route element={<AppShell />}>
      <Route index element={<DashboardPage />} />
      <Route path="/logs" element={<LogsPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Routes>
);

export default App;
